/* ==========================================================================
   Kofra Kit Landing — Kofra Mayorista
   - Selección local del kit (quitar / agregar / variante / sugeridos).
   - Recalcula total, ahorro, pedido mínimo y envío gratis.
   - Agrega todo en una sola llamada a /cart/add.js.
   - Usa las reglas del Cart Drawer KOFRA (mínimo y envío gratis) y abre
     el drawer con su método open(). El drawer no se modifica.
   Nota: la validación del mínimo aquí es informativa. El bloqueo real
   del checkout lo hace el Cart Drawer revalidando /cart.js.
   ========================================================================== */

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-kofra-kl]';

  function routesRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  function readJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[Kofra Kit Landing] JSON inválido', e);
      return null;
    }
  }

  /* Formato de dinero compatible con shop.money_format */
  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = String(format || '${{amount}}').replace(/<[^>]*>/g, '');

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number === null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';
      return whole + fraction;
    }

    var match = fmt.match(placeholder);
    if (!match) return fmt;

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* Cart Drawer KOFRA (<kofra-cart-drawer>). No se modifica: solo se leen
     sus atributos data-* y se usa su método público open(). */
  function findDrawer() {
    return document.querySelector('kofra-cart-drawer');
  }

  /* Mismo criterio que el drawer: metas medidas antes de descuentos. */
  function goalSubtotal(cart) {
    if (!cart) return 0;
    return Number(
      cart.original_total_price != null ? cart.original_total_price :
      cart.items_subtotal_price != null ? cart.items_subtotal_price :
      cart.total_price || 0
    );
  }

  function findVariant(product, variantId) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) return product.variants[i];
    }
    return null;
  }

  function init(root) {
    if (!root || root.__kofraKl) return;

    var data = readJSON(root.querySelector('[data-kofra-kl-data]'));
    if (!data) return;
    root.__kofraKl = true;

    var S = data.strings || {};
    var fmt = function (cents) { return formatMoney(cents, data.moneyFormat); };

    /* ---------- Estado ---------- */
    var catalog = {};
    var kitOrder = [];
    var kit = {};

    (data.products || []).forEach(function (p) {
      var id = String(p.id);
      catalog[id] = p;
      kitOrder.push(id);
      kit[id] = { on: !!p.available, variant: p.variant };
    });

    var extrasCatalog = {};
    var extrasOrder = [];
    var extras = {};

    root.querySelectorAll('[data-kofra-kl-extras-data]').forEach(function (el) {
      var d = readJSON(el);
      if (!d || !d.products) return;
      d.products.forEach(function (p) {
        var id = String(p.id);
        if (catalog[id] || extrasCatalog[id]) return;
        extrasCatalog[id] = p;
        extrasOrder.push(id);
        extras[id] = { on: false, variant: p.variant };
      });
    });

    var busy = false;
    var msgTimer = null;

    /* Reglas: primero las del Cart Drawer; las de la sección son respaldo. */
    var rules = { min: Number(data.min || 0), free: Number(data.free || 0) };

    function readDrawerRules() {
      var drawer = findDrawer();
      if (!drawer) return;
      var d = drawer.dataset;
      rules.min = d.minimumEnabled === 'true' ? Number(d.minimumAmount || 0) : 0;
      rules.free = d.freeShippingEnabled === 'true' ? Number(d.freeShippingAmount || 0) : 0;
    }

    /* Lo que ya hay en el carrito cuenta para las metas, igual que en el drawer. */
    var cartBase = 0;

    function loadCartBase() {
      return fetch(routesRoot() + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          cartBase = goalSubtotal(cart);
          render();
        })
        .catch(function () {});
    }

    /* ---------- Cálculo ---------- */
    function compute() {
      var total = 0;
      var compare = 0;
      var count = 0;
      var items = [];

      function add(product, sel) {
        if (!product || !sel || !sel.on) return;
        var v = findVariant(product, sel.variant);
        if (!v || !v.available) return;
        total += v.price;
        compare += Math.max(v.compare || 0, v.price);
        count += 1;
        items.push({ id: v.id, quantity: 1 });
      }

      kitOrder.forEach(function (id) { add(catalog[id], kit[id]); });
      extrasOrder.forEach(function (id) { add(extrasCatalog[id], extras[id]); });

      return {
        total: total,
        savings: Math.max(0, compare - total),
        count: count,
        items: items
      };
    }

    /* ---------- Render ---------- */
    function each(selector, fn) {
      root.querySelectorAll(selector).forEach(fn);
    }

    function renderGoal(key, target, total, metText) {
      if (!target) return;
      var met = total >= target;
      var pct = Math.min(100, Math.floor((total / target) * 100));

      each('[data-kofra-kl-goal="' + key + '"]', function (el) {
        el.classList.toggle('is-met', met);
      });
      each('[data-kofra-kl-status="' + key + '"]', function (el) {
        el.textContent = met ? metText : (S.missing || 'Faltan [amount]').replace('[amount]', fmt(target - total));
      });
      each('[data-kofra-kl-meter="' + key + '"]', function (el) {
        el.setAttribute('aria-valuenow', String(pct));
        var fill = el.firstElementChild;
        if (fill) fill.style.width = pct + '%';
      });
    }

    function render() {
      var r = compute();

      each('[data-kofra-kl-total]', function (el) { el.textContent = fmt(r.total); });
      each('[data-kofra-kl-count]', function (el) { el.textContent = String(r.count); });
      each('[data-kofra-kl-savings]', function (el) { el.textContent = fmt(r.savings); });
      each('[data-kofra-kl-savings-wrap]', function (el) { el.hidden = r.savings <= 0; });

      var goalTotal = cartBase + r.total;

      each('[data-kofra-kl-goal="min"]', function (el) { el.hidden = !rules.min; });
      each('[data-kofra-kl-goal="free"]', function (el) { el.hidden = !rules.free; });
      each('[data-kofra-kl-amount="min"]', function (el) { el.textContent = fmt(rules.min); });
      each('[data-kofra-kl-amount="free"]', function (el) { el.textContent = fmt(rules.free); });

      renderGoal('min', rules.min, goalTotal, S.minMet || 'Cumplido');
      renderGoal('free', rules.free, goalTotal, S.freeMet || 'Envío gratis');

      each('[data-kofra-kl-cart-note]', function (el) {
        el.hidden = cartBase <= 0;
        el.textContent = cartBase > 0
          ? (S.cartNote || '').replace('[amount]', fmt(cartBase))
          : '';
      });

      each('[data-kofra-kl-extras-status]', function (el) {
        if (!rules.free) {
          el.textContent = '';
          return;
        }
        el.textContent = goalTotal >= rules.free
          ? (S.extrasMet || '')
          : (S.extrasMissing || '').replace('[amount]', fmt(rules.free - goalTotal));
      });

      each('[data-kofra-kl-card]', function (card) {
        var id = card.getAttribute('data-product-id');
        var sel = kit[id];
        var product = catalog[id];
        if (!sel || !product) return;

        card.classList.toggle('is-off', !sel.on && !!product.available);

        var btn = card.querySelector('[data-kofra-kl-toggle]');
        if (btn) btn.setAttribute('aria-pressed', sel.on ? 'true' : 'false');

        var v = findVariant(product, sel.variant);
        if (!v) return;
        var priceEl = card.querySelector('[data-kofra-kl-card-price]');
        if (priceEl) priceEl.textContent = fmt(v.price);
        var compareEl = card.querySelector('[data-kofra-kl-card-compare]');
        if (compareEl) {
          if (v.compare && v.compare > v.price) {
            compareEl.textContent = fmt(v.compare);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      });

      each('[data-kofra-kl-extra]', function (btn) {
        var sel = extras[btn.getAttribute('data-product-id')];
        if (!sel) return;
        btn.setAttribute('aria-pressed', sel.on ? 'true' : 'false');
        var item = btn.closest('[data-kofra-kl-extra-item]');
        if (item) item.classList.toggle('is-added', sel.on);
      });

      var someOff = kitOrder.some(function (id) {
        return catalog[id].available && !kit[id].on;
      });
      each('[data-kofra-kl-reset]', function (el) { el.hidden = !someOff; });

      each('[data-kofra-kl-add]', function (el) {
        el.disabled = busy || r.count === 0;
      });
    }

    /* ---------- Mensajes ---------- */
    function announce(text, isError) {
      var el = root.querySelector('[data-kofra-kl-msg]');
      if (!el) return;
      clearTimeout(msgTimer);
      el.classList.toggle('is-error', !!isError);
      el.textContent = text;
      msgTimer = setTimeout(function () { el.textContent = ''; }, isError ? 7000 : 4000);
    }

    function setBusy(state) {
      busy = state;
      each('[data-kofra-kl-add]', function (el) {
        el.classList.toggle('is-busy', state);
        el.setAttribute('aria-busy', state ? 'true' : 'false');
      });
      render();
    }

    /* ---------- Carrito ---------- */
    function goToCartPage() {
      window.location.href = routesRoot() + 'cart';
    }

    function openFallbackTrigger() {
      var selector = data.drawerTrigger || '[data-kofra-cart-link]';
      var trigger = null;
      try {
        trigger = document.querySelector(selector);
      } catch (e) {
        console.warn('[Kofra Kit Landing] Selector del carrito inválido:', selector);
      }
      if (trigger) {
        trigger.click();
        return true;
      }
      return false;
    }

    /* Después de agregar. Devuelve una promesa. */
    function afterAdd(trigger) {
      var mode = data.afterAdd || 'drawer';
      var drawer = findDrawer();

      if (mode === 'cart') {
        goToCartPage();
        return Promise.resolve();
      }

      if (mode === 'drawer') {
        if (drawer && typeof drawer.open === 'function' && drawer.dataset.enabled === 'true') {
          /* open() refresca el carrito, el contador y las recomendaciones del drawer. */
          return Promise.resolve(drawer.open(trigger)).then(function () {
            if (drawer.cart) {
              cartBase = goalSubtotal(drawer.cart);
              render();
            }
          });
        }
        if (!drawer && openFallbackTrigger()) return Promise.resolve();
        goToCartPage();
        return Promise.resolve();
      }

      /* "stay": el drawer escucha este evento y actualiza carrito y contadores. */
      document.dispatchEvent(new CustomEvent('kofra:cart-mutated', {
        detail: { source: 'kofra-kit-landing' }
      }));
      announce(S.added || 'Productos agregados al carrito.');
      return loadCartBase();
    }

    function addToCart(trigger) {
      if (busy) return;
      var r = compute();
      if (!r.items.length) return;

      setBusy(true);

      fetch(routesRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: r.items })
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (body) {
            if (!res.ok) {
              var detail = body && (body.description || body.message);
              throw new Error(detail || '');
            }
            return body;
          });
        })
        .then(function () {
          return afterAdd(trigger);
        })
        .catch(function (err) {
          var text = S.error || 'No se pudieron agregar los productos.';
          if (err && err.message) text += ' ' + err.message;
          announce(text, true);
          console.error('[Kofra Kit Landing]', err);
        })
        .then(function () {
          setBusy(false);
        });
    }

    /* ---------- Eventos ---------- */
    root.addEventListener('click', function (e) {
      var target = e.target.closest('[data-kofra-kl-toggle], [data-kofra-kl-extra], [data-kofra-kl-reset], [data-kofra-kl-add]');
      if (!target || !root.contains(target)) return;

      if (target.hasAttribute('data-kofra-kl-toggle')) {
        var card = target.closest('[data-kofra-kl-card]');
        var id = card && card.getAttribute('data-product-id');
        if (id && kit[id] && catalog[id].available) {
          kit[id].on = !kit[id].on;
          render();
        }
        return;
      }

      if (target.hasAttribute('data-kofra-kl-extra')) {
        var extraId = target.getAttribute('data-product-id');
        if (extras[extraId]) {
          extras[extraId].on = !extras[extraId].on;
          render();
        }
        return;
      }

      if (target.hasAttribute('data-kofra-kl-reset')) {
        kitOrder.forEach(function (kid) {
          if (catalog[kid].available) kit[kid].on = true;
        });
        render();
        return;
      }

      if (target.hasAttribute('data-kofra-kl-add')) {
        addToCart(target);
      }
    });

    root.addEventListener('change', function (e) {
      var select = e.target.closest('[data-kofra-kl-variant]');
      if (!select) return;
      var card = select.closest('[data-kofra-kl-card]');
      var id = card && card.getAttribute('data-product-id');
      if (id && kit[id]) {
        kit[id].variant = select.value;
        render();
      }
    });

    if (root.querySelector('[data-kofra-kl-sticky]')) {
      document.body.classList.add('kofra-kl-sticky-on');
    }

    readDrawerRules();
    render();
    loadCartBase();

    /* Cuando el drawer se cierra, el carrito pudo cambiar: se relee. */
    var drawerEl = findDrawer();
    if (drawerEl && 'MutationObserver' in window) {
      var wasOpen = drawerEl.classList.contains('is-open');
      new MutationObserver(function () {
        var isOpen = drawerEl.classList.contains('is-open');
        if (wasOpen && !isOpen) loadCartBase();
        wasOpen = isOpen;
      }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('kofra:cart-mutated', loadCartBase);

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) loadCartBase();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme Editor */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.querySelector('[data-kofra-kl-sticky]')) {
      document.body.classList.remove('kofra-kl-sticky-on');
    }
  });
})();